import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-primary-500 whitespace-nowrap">
              韩漫画网
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              韩漫画网提供免费漫画在线阅读，是韩国漫画网站大全的首选平台。内容多样、画质佳，漫画爱好者的必备工具。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
              <Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</Link>
              <Link to="/about#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">常见问题</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/love" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">动作漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">奇幻漫画</Link>
              <Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">悬疑漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫画网 HanManHua.com - 免费漫画在线阅读 &amp; 韩国漫画网站大全
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}